export interface ConnectFlowFormState {
    name: string | null;
    isActive: boolean;
}
